// ============================================================
// DATEI: assets/aa-mj-thumbnail-scroll.js
// ZWECK: Thumbnail-Slider funktioniert auch bei vielen Bildern
//        (mehr als 5) und nach Variantenwechsel korrekt.
// ERSTELLT: 19.06.2026
// THEME-UPDATE-SICHER: JA – diese Datei bleibt bei Updates
//                      erhalten, media-gallery.js wird NICHT
//                      verändert.
// ============================================================
//
// WO EINBINDEN?
// → Onlineshop → Themes → Bearbeiten → Code bearbeiten
// → layout/theme.liquid
// → Ganz unten, direkt VOR der Zeile </body>
// → Diese Zeile einfügen:
//   <script src="{{ 'aa-mj-thumbnail-scroll.js' | asset_url }}" defer></script>
//
// NACH EINEM THEME-UPDATE:
// → Diese Datei hier bleibt automatisch erhalten ✓
// → Nur prüfen ob die Zeile in theme.liquid noch vorhanden ist
//   Falls nicht: Zeile oben erneut vor </body> eintragen
// ============================================================

document.addEventListener('DOMContentLoaded', () => {
  customElements.whenDefined('media-gallery').then(() => {
    const MediaGallery = customElements.get('media-gallery');

    MediaGallery.prototype.setActiveThumbnail = function(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails
        .querySelectorAll('button')
        .forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      // requestAnimationFrame stellt sicher, dass der Slider
      // vollständig gerendert ist bevor wir scrollen
      requestAnimationFrame(() => {
        const slider = this.elements.thumbnails.slider;
        if (!slider) return;

        const sliderRect = slider.getBoundingClientRect();
        const thumbRect = thumbnail.getBoundingClientRect();

        // Sicherheitscheck: wenn Rects noch 0 sind, nochmal warten
        if (sliderRect.width === 0 || thumbRect.width === 0) {
          requestAnimationFrame(() => {
            const sliderRect2 = slider.getBoundingClientRect();
            const thumbRect2 = thumbnail.getBoundingClientRect();
            const scrollLeft = slider.scrollLeft + thumbRect2.left - sliderRect2.left
                               - (sliderRect2.width / 2) + (thumbRect2.width / 2);
            slider.scrollTo({ left: scrollLeft, behavior: 'smooth' });
          });
          return;
        }

        const scrollLeft = slider.scrollLeft + thumbRect.left - sliderRect.left
                           - (sliderRect.width / 2) + (thumbRect.width / 2);
        slider.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      });
    };
  });
});